module.exports = __webpack_public_path__ + "static/media/12.19371cd3.gif";